import SignalRConnection from '../services/SignalRConnection';
import { AnnouncementHub, Announcement } from '../api/AnnouncementHub';

class VirtualEventAnnouncements {
  private announcemenHub: AnnouncementHub;
  private eventId: number;
  public onAnnouncementBroadcasted!: {
        (msg: Announcement): void;
    };

  constructor (readonly _eventId: number, readonly _tokenEndpoint: string, readonly _hubEndpoint: string) {
    this.announcemenHub = new AnnouncementHub(_tokenEndpoint, _hubEndpoint + 'announcements');
    this.announcemenHub.onAnnouncement = (message) => this.broadcastAnnouncement(message);
    this.eventId = _eventId;
  }

  broadcastAnnouncement (message: Announcement) {
    this.onAnnouncementBroadcasted(message);
  }

  public run () {
    this.announcemenHub.connect().then(() => {
      this.announcemenHub.joinAnnouncements(this.eventId);
    });
  }
}

if (!window.causeMachine) {
  window.causeMachine = {};
}

window.causeMachine.announcementService = VirtualEventAnnouncements;
